<template>
  <div class="py-4 space-y-6">
    <!-- Title -->
    <div class="text-center mb-6">
      <h1 class="text-xl font-bold text-foreground mb-2">
        {{ $t('report.members_overview_info.title') }}
      </h1>
      <p class="text-sm text-muted-foreground leading-relaxed max-w-xs mx-auto">
        {{ $t('report.members_overview_info.description') }}
      </p>
    </div>

    <!-- How to read -->
    <div class="space-y-4">
      <div class="flex items-center gap-2">
        <div class="w-1 h-3.5 rounded-full" style="background: #06C8FF"></div>
        <h2 class="text-sm font-bold uppercase tracking-wide text-foreground">
          {{ $t('report.members_overview_info.how_to_read') }}
        </h2>
      </div>

      <!-- Mini illustration matching the actual card layout -->
      <div class="rounded-lg p-3 info-example-bg">
        <div class="text-center mb-2">
          <span class="text-[24px] font-extrabold text-foreground leading-none">256</span>
          <div class="flex items-center justify-center gap-1.5 mt-0.5">
            <span class="text-[9px] text-muted-foreground">{{ $t('report.members_total') }}</span>
            <span class="inline-flex items-center px-1.5 py-0.5 rounded-full text-[8px] font-bold" style="background: rgba(22,163,74,0.10); color: #16A34A">+5.3 %</span>
          </div>
        </div>
        <div class="flex w-full h-1.5 rounded-full overflow-hidden mb-1.5">
          <span class="h-full" style="background-color: #10B981; width: 72%"></span>
          <span class="h-full" style="background-color: #94A3B8; width: 28%"></span>
        </div>
        <div class="flex justify-between">
          <span class="text-[8px] font-semibold" style="color: #10B981">{{ $t('report.members_active') }} 184 (72%)</span>
          <span class="text-[8px] font-semibold" style="color: #94A3B8">{{ $t('report.members_inactive') }} 72 (28%)</span>
        </div>
      </div>

      <!-- Indicator descriptions -->
      <div class="space-y-3">
        <div class="flex items-start gap-2.5">
          <span class="w-2.5 h-2.5 rounded-full shrink-0 mt-1" style="background: #06C8FF"></span>
          <div>
            <span class="text-xs font-semibold text-foreground">{{ $t('report.members_overview_info.total_label') }}</span>
            <p class="text-xs text-muted-foreground leading-relaxed mt-0.5">
              {{ $t('report.members_overview_info.total_desc') }}
            </p>
          </div>
        </div>

        <div class="flex items-start gap-2.5">
          <span class="w-2.5 h-2.5 rounded-full shrink-0 mt-1" style="background: #10B981"></span>
          <div>
            <span class="text-xs font-semibold text-foreground">{{ $t('report.members_overview_info.active_label') }}</span>
            <p class="text-xs text-muted-foreground leading-relaxed mt-0.5">
              {{ $t('report.members_overview_info.active_desc') }}
            </p>
          </div>
        </div>

        <div class="flex items-start gap-2.5">
          <span class="w-2.5 h-2.5 rounded-full shrink-0 mt-1" style="background: #94A3B8"></span>
          <div>
            <span class="text-xs font-semibold text-foreground">{{ $t('report.members_overview_info.inactive_label') }}</span>
            <p class="text-xs text-muted-foreground leading-relaxed mt-0.5">
              {{ $t('report.members_overview_info.inactive_desc') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Evolution explanation -->
    <div class="space-y-2">
      <div class="flex items-center gap-2">
        <div class="w-1 h-3.5 rounded-full" style="background: #06C8FF"></div>
        <h2 class="text-sm font-bold uppercase tracking-wide text-foreground">
          {{ $t('report.members_overview_info.evolution_section') }}
        </h2>
      </div>
      <p class="text-xs text-muted-foreground leading-relaxed ml-3">
        {{ $t('report.members_overview_info.evolution_desc') }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
// Content-only component — no props needed.
// Injected into a BottomSheet from CenterMembersReport.
</script>

<style scoped>
.info-example-bg {
  background: rgba(107, 114, 128, 0.06);
  border: 1px solid rgba(107, 114, 128, 0.1);
}
:is(.dark *).info-example-bg {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
}
</style>
